import { createContext } from 'react';

import { IBAuth0Role } from '@totem/components/administration/auth0/roles/types';

interface Context {
  loading: boolean;
  roles: IBAuth0Role[];
  onRefresh: () => void;
  buildingId?: string;
  buildingName?: string;
}

export default createContext<Context>({
  loading: false,
  roles: [],
  onRefresh: () => {},
});
